import { Tab, Tabs } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './TabPages.scss';
import { SYSTEM_CONFIGURATION_TAB } from '@utils/constants/enums';

interface TabPagesProps {
  value: string;
  options: Option[];
  onChangeValue: (value: SYSTEM_CONFIGURATION_TAB) => void;
}

const TabPages: FC<TabPagesProps> = ({ value, options, onChangeValue }) => {
  const { t } = useTranslation();

  return (
    <Tabs
      className='TabPages'
      value={value}
      onChange={(_, value) => onChangeValue(value)}
      TabIndicatorProps={{ hidden: true }}
    >
      {options.map(({ value, label }) => (
        <Tab key={value} value={value} label={t(label)} />
      ))}
    </Tabs>
  );
};

export default TabPages;
